export const FEATURE = {
  trading: 'trading',
  watchlist: 'watchlist',
} as const;

export type FeatureType = keyof typeof FEATURE;

export type WatchlistGroup = `watchlist${number}`;

export const GROUP = {
  watchlist: 'watchlist',
} as const;

export type GroupType = keyof typeof GROUP | WatchlistGroup;

export const METADATA_KEY = {
  name: 'name',
  issuers: 'issuers',
  isMigrated: 'isMigrated',
  order: 'order',
} as const;

export type MetadataKeyType = keyof typeof METADATA_KEY;

export type Metadata<TKey = string> = {
  key: TKey;
  value: string;
};

export type GetUserPreferences = {
  featureId: FeatureType;
};

export type UserPreferences<TGroup = GroupType, TMetaKey = MetadataKeyType> = {
  id?: string;
  group_id: TGroup;
  metadata: Metadata<TMetaKey>[];
};

export interface LegacyWatchList {
  name: string;
  order: number;
  watch_list: string;
}
